import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBxxxxxx';
const DEBUG = String(process.env.DEBUG || '').toLowerCase() === 'true';

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: undefined,
});

export function useGoogleMapsReady() {
  return useContext(GoogleMapsContext);
}

export function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-maps-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  useEffect(() => {
    if (DEBUG && isLoaded) {
      console.log('Google Maps API ready');
    }
  }, [isLoaded]);

  useEffect(() => {
    if (DEBUG && loadError) {
      console.error('Error loading Google Maps API:', loadError);
    }
  }, [loadError]);

  const value = useMemo(() => ({ isLoaded, loadError }), [isLoaded, loadError]);

  return <GoogleMapsContext.Provider value={value}>{children}</GoogleMapsContext.Provider>;
}
